define([
    './slider',
    './hexToFilter',
], function (
    Slider,
    hexToFilter,
) {
    // obj
    var _self = {
        toggleAuthorPopup() {
            $('.author').toggleClass('author--popup');
        }
    };

    // -------------------
    // BINDS
    // -------------------

    $('.author-popup-close').on('click', function () {
        _self.toggleAuthorPopup();
    });

    $('.author__name').on('click', function () {
        _self.toggleAuthorPopup();
    });

    $('#connect-load-more').on('click', function () {
        const button = $(this);

        button.attr('disabled', 'disabled');

        $.ajax({
            type: 'GET',
            url: button.attr('data-action'),
            cache: false,
            dataType: 'json',
            success: function (response) {
                const articles = response.list;
                const action = response.action;

                $('#connect-article-list').append(articles);
                button.removeAttr('disabled');

                if (action) {
                    button.attr('data-action', action)
                } else {
                    button.remove();
                }
            },
            error: function (error) {
                button.removeAttr('disabled');
            },
        });
    });

    // update comments count in article header
    $(document).on('comments:data-changed', function (event) {
        $('.connect-content__comments-counter .note').text(event.detail.count);
    });

    $(document).on('comments:publish-unregistered', function (event) {
        $('#login-modal').modal('show');
    });

    var categoryColor = $('[data-category-color]').attr('data-category-color');
    if (typeof categoryColor != 'undefined') {
        var categoryColorFilter = hexToFilter(categoryColor).filter.replace('filter: ', '').slice(0, -1);

        console.log(categoryColorFilter);

        $(':root').css({
            '--category-color': categoryColor,
            '--category-color-filter': categoryColorFilter,
        });
    }
});
